<template>
  <v-layout
    align-center
    justify-center
  >
    <v-layout column>
      <v-flex
        md4
        shrink
        class="py-0 pl-2"
      >
        <v-layout>
          <v-flex md4 class="pl-2">
            <label class="cmr-label-text">Associated Taxi</label>
            <v-autocomplete
              v-model="taxiStore"
              :error-messages="errorForField()"
              :items="taxis"
              :loading="loading"
              :search-input.sync="search"
              item-text="registration_number"
              dense
              outlined
              placeholder="Search by registration or plate number"
              hide-no-data
              hide-selected
              no-filter
              return-object
              :disabled="false"
              hide-details
              @input="handleSelected"
            >
              <template v-slot:item="{ item }">
                {{ item.registration_number }} | {{ item.plate_number }} | {{ getTaxiVerificationState(item.taxi_verification_state) }}
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        xs12
        md12
        class="py-0"
      >
        <TaxiForm
          ref="taxiViewForm"
          :disabled="true"
          :taxi="taxi"
          :ride-types="[]"
          :councils="[]"
        />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import TaxiForm from "@/components/driver/TaxiFormV2.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "SelectTaxiV2",
  components: {
    TaxiForm
  },
  props: {
    taxi: Object,
    errors: { type: Object, default: () => {} }
  },
  data: function() {
    return {
      taxiStore: {},
      loading: false,
      taxis: [],
      search: null
    };
  },
  watch: {
    search(query) {
      console.log(query);
      this.resetError();

      if (query == null) return;
      if (query.length <= 2) return;
      if (this.loading) return;

      this.loading = true;
      let self = this;
      let url = `${this.$store.state.apiUrl}/taxi/search?query=${query}`;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          self.taxis = res.data.taxis;
          self.loading = false;
        })
        .catch(function(err) {
          console.error(err);
          self.loading = false;
        });
    },
    taxi: function() {
      this.taxiStore = this.taxi;
    }
  },
  methods: {
    handleSelected: function() {
      this.$emit("taxiChange", this.taxiStore);
    },
    errorForField: function() {
      try {
        return this.errors["use_existing"];
      } catch (err) {
        return null;
      }
    },
    resetError: function() {
      try {
        if (this.errors["use_existing"] != "") {
          this.errors["use_existing"] = "";
        }
      } catch (err) {
          console.log(err)
      }
    },
    getTaxiVerificationState: function(state) {
      if (state === "verification_approved") {
        return "Verified";
      } else if (state === "verification_pending") {
        return "Pending";
      } else if (state === "verification_rejected") {
        return "Rejected";
      } else {
        return "Pending";
      }
    }
  }
};
</script>